<mat-dialog-content>
  <div class="flex flex-col items-center w-full p-4">
    Plan wirklich beenden?
    <!-- Actions -->
    <div class="flex justify-between w-full mt-6">
      <button
        mat-flat-button
        color="warn"
        class="w-1/2 ml-2"
        (click)="onCancel()"
      >
        Plan beenden
      </button>

      <button
        mat-stroked-button
        class="w-1/2 mr-2"
        (click)="dialogRef.close()"
      >
        {{ 'ACTION.CLOSE' | translate }}
      </button>


    </div>
  </div>
</mat-dialog-content>
